import { useState,useEffect } from "react";
import { motion, AnimatePresence  } from "framer-motion";
import { BookOpen, Eye, User, FileText, Calendar, Users, Phone, Search } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function AlumniPage({ 
  accent = "#115e32",
  pageTitle = "Office of Career Services and Alumni Relations (OCSAR) | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  const tabs = [
    { id: "about", label: "About OCSAR", icon: <BookOpen size={18} /> },
    { id: "vision", label: "Vision and Mission", icon: <Eye size={18} /> },
    { id: "message", label: "Message from the Director, OCSAR", icon: <User size={18} /> },
    { id: "services", label: "Program and Services", icon: <FileText size={18} /> },
    { id: "registration", label: "Alumni Registration", icon: <Calendar size={18} /> },
    { id: "directory", label: "Alumni Directory", icon: <Users size={18} /> },
	{ id: "news", label: "Alumni News", icon: <FileText size={18} /> },
	{ id: "team", label: "OCSAR Team", icon: <User size={18} /> },
    { id: "contact", label: "Contact OCSAR", icon: <Phone size={18} /> },
  ];

	const [activeTab, setActiveTab] = useState("about");
	const [step, setStep] = useState(1);
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState(null);
	const [messageType, setMessageType] = useState(""); // success | error
	const [form, setForm] = useState({
		token: "",
		studentId: "",
		studentName: "",
		cgpa: "",
		email: "",
		mobile: "",
		dob: "",
		presentAddress: "",
		profession: "",
		companyName: "",
		designation: "",
		companyAddress: "",
		picture: null,
	});
	
	const [alumni, setAlumni] = useState([]);
	const [filtered, setFiltered] = useState([]);
	const [search, setSearch] = useState("");
	const [page, setPage] = useState(1);
	const [limit] = useState(12); // cards per page
	const [error, setError] = useState(null);
	const fetchStudentName = async (id) => {
		if (!id) return;
		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,	
				matric_no:id,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/name", payload);
			if (res.data?.name) {
				setForm((prev) => ({ ...prev, studentName: res.data.name || "" }));
			}else {
				setMessageType("error");
				setMessage("Invalid Student ID");
			}
		} catch {
			setForm((prev) => ({ ...prev, studentName: "" }));
		}
    };

	const handleChange = (e) => {
		const { name, value, files } = e.target;
		if (name === "picture") {
		  setForm((prev) => ({ ...prev, picture: files[0] }));
		} else {
		  setForm((prev) => ({ ...prev, [name]: value }));
		}
	};

  // Step 1: Take a Token
	const handleStepOneSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				matric_no: form.studentId,
				studentName: form.studentName,
				cgpa: form.cgpa,
				email: form.email,
				mobile: form.mobile,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/alumni-token", payload);
			const { responseCode, responseMsg } = res.data;
			
			if (responseCode === "200") {
				setMessageType("success");
				setMessage(responseMsg);
				alert("Token has been sent to your Email/Mobile. Please check your inbox.");
				setStep(2);
			} else {
				setMessageType("error");
				setMessage(responseMsg);
			}	
			
		} catch {
		    setMessageType("error");
			setMessage("Server error. Please try again.");
		} finally {
		  setLoading(false);
		}
	};

  // Step 2: Complete Registration
	const handleStepTwoSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		const formData = new FormData();
		Object.entries(form).forEach(([k, v]) => formData.append(k, v));

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				token: form.token,
				studentId: form.studentId,
				studentName: form.studentName,
				cgpa: form.cgpa,
				email: form.email,
				mobile: form.mobile,
				dob: form.dob,
				presentAddress: form.presentAddress,
				profession: form.profession,
				companyName: form.companyName,
				designation: form.designation,
				companyAddress: form.companyAddress,
				picture: form.picture,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "multipart/form-data" },
			});
			const res = await api.post("/alumni-registration", payload);
			const { responseCode, responseMsg } = res.data;
			
			if (responseCode === "200") {
				setMessageType("success");
				setMessage("Registration completed successfully!");
				setForm({
					token: "",
					studentId: "",
					studentName: "",
					cgpa: "",
					email: "",
					mobile: "",
					dob: "",
					presentAddress: "",
					profession: "",
					companyName: "",
					designation: "",
					companyAddress: "",
					picture: null,
				});
			} else {
				setMessageType("error");
				setMessage(responseMsg);
			}
		} catch {
		  setMessageType("error");
		  setMessage("Registration failed. Please try again.");
		} finally {
		  setLoading(false);
		}
	};
	const alumniPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,				
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/alumni-directory", payload);
			
			// Loop data (array)
			setAlumni(response.data || []);
			setFiltered(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {
		alumniPost();		
	}, []);
	
	useEffect(() => {
		const q = search.toLowerCase();
		const result = alumni.filter(
		  (a) =>
			a.name.toLowerCase().includes(q) ||
			a.department.toLowerCase().includes(q) ||
			a.companyName.toLowerCase().includes(q)
		);
		setFiltered(result);
		setPage(1);
	}, [search, alumni]);
	
	const totalPages = Math.ceil(filtered.length / limit);
	const currentData = filtered.slice((page - 1) * limit, page * limit);

	const nextPage = () => setPage((p) => Math.min(p + 1, totalPages));
	const prevPage = () => setPage((p) => Math.max(p - 1, 1));
	
  const inputClass =
    "w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400";
  const content = {
    about: (
      <p> 
		<strong>About OCSAR</strong><br/>
		UCTC Office of Career Services and Alumni Relations (OCSAR) is a dedicated department, vested with the duty to facilitate its students’ efficient and effective transition into their professional life which will ultimately lead to successful career for them.
		<br/><br/>
		OCSAR is a platform where students are prepared to end their academic journey and begin a new journey as proud alumni of UCTC .
	  </p>
    ),
    vision: (
      <p>
        <strong>Mission:</strong><br/>
		OCSAR’s vision is to empower students and alumni to achieve success in the ‘world of work’ and ensure that they have the right competencies, skills set and overall approach for professional success.
		
		<br/><br/><strong>Vision:</strong><br/>
		Mission of OCSAR is to provide an integrated range of high quality career-focused services which meet the needs of our graduating students and prepares them for professional success. We aspire to create well rounded, socially aware, responsible human beings and conscious citizens.
		</p>
    ),
    message: (
      <p>
		<strong>Message from the Director, OCSAR</strong><br/>
        Welcome to the Office of Career Services & Alumni Relations (OCSAR) of University of Creative Technology Chittagong (UCTC). The OCSAR’s commitment to you is lifelong. Whether you are an undergraduate, an alumnus, the Office of Career Services & Alumni Relations (OCSAR) is eager to help you achieve your goals. You will find that our staffs, programs, and resources are ready to support you in the best possible way we can. We look forward to assist students and alumni with career exploration and professional development.
      </p>
    ),
    services: (
		<div className="w-full animate-fadeInRight">
            <img
              src="/img/program-service-ocsar.png"
              alt="UCTC Illustration"
              className="w-[100%] mx-auto drop-shadow-xl object-cover"
            />
        </div>
    ),
    registration: (
		<div className="flex justify-center items-center min-h-screen bg-gradient-to-b from-[#B7EAFC] to-[#F0FCFF]">
		  <motion.div
			className="bg-white p-2 rounded-2xl shadow-xl w-full"
			initial={{ opacity: 0, y: 40 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
		  >
        <h2 className="text-2xl font-semibold text-center mb-6 text-gray-700">
          {step === 1 ? "Step 1: Take a Token" : "Step 2: Complete Registration"}
        </h2>
		{message && (
			<div
			  className={`p-3 mb-4 text-sm rounded-md ${
				messageType === "success" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
			  }`}
			>
			  {message}
			</div>
		)}
        <AnimatePresence mode="wait">
          {step === 1 ? (
            <motion.form
              key="step1"
              onSubmit={handleStepOneSubmit}
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.4 }}
              className="space-y-4"
            >
			<div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="block mb-1 font-medium">Student ID *</label>
                <input
                  type="text"
                  name="studentId"
                  value={form.studentId}
                  onChange={(e) => {
                    handleChange(e);
                    fetchStudentName(e.target.value);
                  }}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Student Name *</label>
                <input
                  type="text"
                  name="studentName"
                  value={form.studentName}
                  className={inputClass}
                  readOnly
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">CGPA *</label>
                <input
                  type="text"
                  name="cgpa"
                  value={form.cgpa}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Mobile Number *</label>
                <input
                  type="text"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  maxLength={11}
                  pattern="\d{11}"
                  className={inputClass}
                  required
                />
              </div>
			</div>  
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white py-3 rounded-lg font-semibold transition"
              >
                {loading ? "Submitting..." : "Send Token"}
              </button>
            </motion.form>
          ) : (
            <motion.form
              key="step2"
              onSubmit={handleStepTwoSubmit}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.4 }}
              className="space-y-4"
            >
			<div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="block mb-1 font-medium">Token *</label>
                <input
                  type="text"
                  name="token"
                  value={form.token}
                  onChange={handleChange}
                  placeholder="Enter the token sent to your email/mobile"
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Student ID *</label>
                <input
                  type="text"
                  name="studentId"
                  value={form.studentId}
                  onChange={(e) => {
                    handleChange(e);
                    fetchStudentName(e.target.value);
                  }}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Student Name *</label>
                <input
                  type="text"
                  name="studentName"
                  value={form.studentName}
                  className={inputClass}
                  readOnly
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">CGPA *</label>
                <input
                  type="text"
                  name="cgpa"
                  value={form.cgpa}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Date of Birth *</label>
                <input
                  type="date"
                  name="dob"
                  value={form.dob}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Mobile Number *</label>
                <input
                  type="text"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  maxLength={11}
                  pattern="\d{11}"
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Present Address *</label>
                <textarea
                  name="presentAddress"
                  value={form.presentAddress}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Profession *</label>
                <input
                  type="text"
                  name="profession"
                  value={form.profession}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Present Company Name</label>
                <input
                  type="text"
                  name="companyName"
                  value={form.companyName}
                  onChange={handleChange}
                  className={inputClass}
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Designation</label>
                <input
                  type="text"
                  name="designation"
                  value={form.designation}
                  onChange={handleChange}
                  className={inputClass}
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Company Address</label>
                <textarea
                  name="companyAddress"
                  value={form.companyAddress}
                  onChange={handleChange}
                  className={inputClass}
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Upload Picture *</label>
                <input
                  type="file"
                  name="picture"
                  accept="image/*"
                  onChange={handleChange}
                  className={inputClass}
                  required
                />
              </div>
			 </div>
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => setStep(1)}
                  className="w-1/2 bg-gray-300 hover:bg-gray-400 text-gray-700 py-3 rounded-lg font-semibold transition"
                >
                  Back
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-1/2 bg-yellow-500 hover:bg-yellow-600 text-white py-3 rounded-lg font-semibold transition"
                >
                  {loading ? "Submitting..." : "Submit Registration"}
                </button>
              </div>
            </motion.form>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
    ),
    directory: (
      <section className="max-w-7xl mx-auto px-6 py-12">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-center mb-6 text-gray-800"
      >
        Alumni Directory
      </motion.h2>

      {/* Search Bar */}
      <div className="flex justify-center mb-8">
        <div className="relative w-full max-w-md">
          <Search className="absolute left-3 top-2.5 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name, department, or company..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border border-gray-300 rounded-full py-2 pl-10 pr-4 focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>
      </div>

      {/* Alumni Grid */}
      {loading ? (
        <p className="text-center text-gray-500">Loading alumni data...</p>
      ) : filtered.length === 0 ? (
        <p className="text-center text-gray-500">No alumni found.</p>
      ) : (
        <motion.div
		  layout
		  className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"
		>
		  {currentData.map((a, idx) => (
			<motion.div
			  key={a.id || idx}
			  initial={{ opacity: 0, y: 20 }}
			  animate={{ opacity: 1, y: 0 }}
			  transition={{ delay: idx * 0.05 }}
			  className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300"
			>
			  {/* Image Section */}
			  <div className="aspect-[4/5] w-full bg-gray-100 flex items-center justify-center p-2">
				<img
				  src={
					a.picture
					  ? `${import.meta.env.VITE_API_SOURCE_URL}${a.picture}`
					  : "/default-profile.png"
				  }
				  alt={a.name}
				  className="w-full h-full object-contain"
				  onError={(e) => {
					e.target.src = "/default-profile.png";
				  }}
				/>
			  </div>

			  {/* Content Section */}
			  <div className="p-4">
				<h3 className="font-semibold text-lg text-gray-800">
				  {a.name}
				</h3>

				<p className="text-sm text-gray-500">
				  {a.matric_no}
				</p>

				<p className="text-sm text-gray-500 mb-3">
				  {a.department_name}
				</p>

				<div className="space-y-1">
				  <p className="text-sm text-gray-700">
					<span className="font-semibold">Profession:</span>{" "}
					{a.profession || "N/A"}
				  </p>

				  <p className="text-sm text-gray-700">
					<span className="font-semibold">Company:</span>{" "}
					{a.company_name || "N/A"}
				  </p>

				  <p className="text-sm text-gray-700">
					<span className="font-semibold">Designation:</span>{" "}
					{a.designation || "N/A"}
				  </p>
				</div>
			  </div>
			</motion.div>
		  ))}
		</motion.div>
      )}

      {/* Pagination */}
      {filtered.length > limit && (
        <div className="flex justify-center items-center mt-8 space-x-3">
          <button
            onClick={prevPage}
            disabled={page === 1}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            <ChevronLeft />
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => setPage(i + 1)}
              className={`px-4 py-1 rounded-full text-sm ${
                page === i + 1
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={nextPage}
            disabled={page === totalPages}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            <ChevronRight />
          </button>
        </div>
      )}
    </section>
    ),
	news: (
      <p>
       </p>
    ),
	team: (
      <p>
       </p>
    ),
    contact: (
      <p>
		<strong>Contact Office of Career Services and Alumni Relations (OCSAR) to the following;;</strong><br/>
		<strong>Location:</strong> 1st Floor, UCTC Campus<br/>
		<strong>Hours:</strong> Monday through Saturday, 9.00 AM to 6.00 PM<br/>
        <strong>Email:</strong> ocsar@uctc.edu.bd <br />
        <strong>Phone:</strong> 8801707507071 <br />
        <strong>Mailing Address:</strong> Student Affairs Division, University of Creative Technology, Chittagong, 1084, Near New Chandgaon Police Station, Shah Amanat Bridge Connecting Road, Bahaddarhat, Chittagong, Bangladesh
      </p>
    ),
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#fffdf7] to-white">
      {/* Hero Section with SVG */}
      <section className="relative bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE] text-[#014864] py-20 overflow-hidden">
        {/* SVG Wave */}
        <svg
          className="absolute bottom-0 left-0 w-full h-20 text-white"
          viewBox="0 0 1440 320"
          fill="currentColor"
        >
          <path
            fillOpacity="1"
            d="M0,192L80,202.7C160,213,320,235,480,224C640,213,800,171,960,144C1120,117,1280,107,1360,101.3L1440,96V320H0Z"
          ></path>
        </svg>
        <div className="relative container mx-auto text-center z-10">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold"
          >
            Office of Career Services and Alumni Relations (OCSAR)
          </motion.h1>
          <p className="mt-4 text-lg opacity-90">
            Supporting students’ academic journey, leadership, and campus life.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="mx-auto px-6 py-16 grid md:grid-cols-4 gap-8">
        {/* Left Menu */}
        <div className="col-span-1 bg-white rounded-xl shadow-lg p-6">
          <ul className="space-y-3">
            {tabs.map((tab) => (
              <li key={tab.id}>
                <button
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 w-full px-4 py-2 rounded-lg text-left transition ${
                    activeTab === tab.id
                      ? "bg-gradient-to-r from-[#2563eb] to-[#014864] text-white shadow"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  {tab.icon} {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Content */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="col-span-3 bg-white rounded-xl shadow-lg p-8 text-gray-700 leading-relaxed"
        >
          {content[activeTab]}
        </motion.div>
      </section>
    </div>
  );
}
